export default __webpack_public_path__ + "static/media/947.0f2e8660.gif";